import React, { useContext, useEffect, useState } from 'react';  
import { useNavigate, useParams } from "react-router-dom";  
import Alert from '../components/Alert';  
import Spinner from '../components/Spinner';  
import ResultContext from '../context/ResultContext';  
import '../styles/createquiz.css';  

export default function UpdatePremiumBatch() {  
  const navigate = useNavigate();  
  const { batchId } = useParams();  
  const [name, setName] = useState("");  
  const [subject, setSubject] = useState("");  
  const [password, setPassword] = useState("");  
  const [description, setDescription] = useState("");  
  const [price, setPrice] = useState("");  
  const [whatsappLink, setWhatsappLink] = useState("");  
  const [imageUrl, setImageUrl] = useState(null);  
  const [currentImageUrl, setCurrentImageUrl] = useState(""); // Store existing image URL
  const [passwordVisible, setPasswordVisible] = useState(false);  
  const [spinner, setSpinner] = useState(false);  
  const [uploading, setUploading] = useState(false);
  
  const HOST = process.env.REACT_APP_HOST_NAME;  
  const { setAlertContext } = useContext(ResultContext);  

  useEffect(() => {  
    fetchBatchDetails();
  }, [batchId]);  

  const fetchBatchDetails = async () => {  
    try {  
      setSpinner(true);  
      const response = await fetch(`${HOST}api/get-premium-batch/${batchId}`, {  
        method: 'GET',  
        headers: {  
          'Content-Type': 'application/json',  
          'Authorization': `Bearer ${localStorage.getItem('token')}` // ✅ Updated header
        }  
      });  

      const data = await response.json();

      if (!response.ok) {  
        throw new Error(data.message || 'Failed to fetch batch details');  
      }  

      // ✅ Populate all fields including new ones
      setName(data.batch?.name || data.name || "");  
      setSubject(data.batch?.subject || data.subject || "");  
      setPassword(data.batch?.password || data.password || "");  
      setDescription(data.batch?.description || data.description || "");  
      setPrice(data.batch?.price || data.price || "");  
      setWhatsappLink(data.batch?.whatsappLink || data.whatsappLink || "");  
      setCurrentImageUrl(data.batch?.imageUrl || data.imageUrl || "");  
      
    } catch (error) {  
      showAlert(error.message || 'There was a problem fetching the batch details', 'danger');  
      console.error('Error fetching batch:', error);
    } finally {  
      setSpinner(false);  
    }  
  };  

  const showAlert = (message, status) => {  
    setAlertContext({  
      isActive: true,  
      message: message,  
      status: status  
    });  
    setTimeout(() => {  
      setAlertContext(prevState => ({ ...prevState, isActive: false }));  
    }, 2000);  
  };  

  // ✅ Updated to use backend Cloudinary upload
  const uploadImage = async (file) => {  
    try {
      setUploading(true);
      const formData = new FormData();  
      formData.append("mainImg", file);  
      formData.append("name", name); // For unique public_id

      const response = await fetch(`${HOST}api/upload-batch-image`, {  
        method: "POST",  
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData  
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Image upload failed');
      }

      showAlert('Image Uploaded Successfully', 'success');  
      return data.imageUrl || data.secure_url;
      
    } catch (error) {
      showAlert(error.message || 'Error uploading image!', 'danger');  
      throw error;
    } finally {
      setUploading(false);
    }
  };  

  const updateBatch = async () => {  
    // ✅ Validation
    if (!name || !subject) {
      showAlert('Name and subject are required', 'danger');
      return;
    }

    setSpinner(true);  
    
    try {  
      let finalImageUrl = currentImageUrl; // Use existing image by default
      
      // ✅ Only upload if new image is selected
      if (imageUrl instanceof File) {  
        finalImageUrl = await uploadImage(imageUrl);
      }  

      const batchObj = {  
        name,  
        subject,  
        password,  
        description,  
        price: price || 0,
        whatsappLink: whatsappLink || "https://wa.me/7745002013",
        imageUrl: finalImageUrl  
      };  

      // console.log("Updating batch with:", batchObj);

      const url = `${HOST}api/update-premium-batch/${batchId}`;  
      const response = await fetch(url, {  
        method: 'PUT',  
        headers: {  
          'Content-Type': 'application/json',  
          'Authorization': `Bearer ${localStorage.getItem('token')}` // ✅ Updated header
        },  
        body: JSON.stringify(batchObj),  
      });  

      const data = await response.json();

      if (!response.ok) {  
        throw new Error(data.message || 'Failed to update batch');  
      }  

      showAlert('Batch Updated Successfully!!', 'success');  
      
      setTimeout(() => {
        navigate('/allpremiumbatches');  
      }, 1000);

    } catch (error) {  
      showAlert(error.message || 'There was a problem updating the batch', 'danger');  
      console.error('Error updating batch:', error);
    } finally {
      setSpinner(false);  
    }
  };  

  return (  
    <>  
      {spinner && <Spinner />}  
      <div className="container">  
        <div className="header">  
          <h1>Update Premium Batch</h1>  
        </div>  
        <div className="row">  
          <div className="col-md-6">  
            <form className="centered-form" onSubmit={(e) => e.preventDefault()}>  
              <div className="form-floating mt-1">  
                <input  
                  type="text"  
                  className="form-control"  
                  id="name"  
                  name="name"  
                  placeholder="Name"  
                  value={name}  
                  onChange={(e) => setName(e.target.value)}  
                  required
                />  
                <label htmlFor="name">Name *</label>  
              </div>  

              <div className="form-floating mt-3">  
                <input  
                  type="text"  
                  className="form-control"  
                  id="subject"  
                  name="subject"  
                  placeholder="Subject"  
                  value={subject}  
                  onChange={(e) => setSubject(e.target.value)}  
                  required
                />  
                <label htmlFor="subject">Subject *</label>  
              </div>  

              <div className="form-floating mt-3">  
                <input  
                  type={passwordVisible ? "text" : "password"}  
                  className="form-control"  
                  id="password"  
                  name="password"  
                  placeholder="Password"  
                  value={password}  
                  onChange={(e) => setPassword(e.target.value)}  
                />  
                <label htmlFor="password">Password (Optional)</label>  
                <div className="mt-2">  
                  <input  
                    type="checkbox"  
                    checked={passwordVisible}  
                    onChange={() => setPasswordVisible(!passwordVisible)}  
                  /> Show Password  
                </div>  
              </div>  

              <div className="form-floating mt-3">  
                <input  
                  type="number"  
                  className="form-control"  
                  id="price"  
                  name="price"  
                  placeholder="Price"  
                  value={price}  
                  onChange={(e) => setPrice(e.target.value)}  
                  min="0"
                />  
                <label htmlFor="price">Price (₹)</label>  
              </div>  

              <div className="form-floating mt-3">  
                <input  
                  type="url"  
                  className="form-control"  
                  id="whatsappLink"  
                  name="whatsappLink"  
                  placeholder="WhatsApp Link"  
                  value={whatsappLink}  
                  onChange={(e) => setWhatsappLink(e.target.value)}  
                />  
                <label htmlFor="whatsappLink">WhatsApp Link</label>  
              </div>  

              <div className="form-group mt-3">  
                <label htmlFor="description">Description: </label>  
                <textarea  
                  className="form-control"  
                  id="description"  
                  name="description"  
                  rows="3"  
                  value={description}  
                  onChange={(e) => setDescription(e.target.value)}  
                ></textarea>  
              </div>  

              <div className="form-group mt-3">
                <label htmlFor="image" style={{ marginBottom: "10px" }}>
                  Update Image (Optional)
                </label>  
                <br />  
                
                {currentImageUrl && !imageUrl && (
                  <div className="mb-2">
                    <img 
                      src={currentImageUrl} 
                      alt="Current batch" 
                      style={{ maxWidth: '200px', maxHeight: '200px' }}
                      className="img-thumbnail"
                    />
                    <p className="text-muted small">Current Image</p>
                  </div>
                )}

                <input 
                  type="file" 
                  id="image"
                  onChange={(e) => setImageUrl(e.target.files[0])} 
                  accept="image/*" 
                />
                
                {imageUrl && (
                  <small className="text-muted d-block mt-2">
                    New image selected: {imageUrl.name}
                  </small>
                )}
              </div>

              <div className="d-flex justify-content-center mt-3">  
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={updateBatch}
                  disabled={spinner || uploading}
                >
                  {spinner ? 'Updating...' : uploading ? 'Uploading Image...' : 'Update Batch'}
                </button>  
              </div>  
            </form>  
          </div>  
        </div>  
      </div>  
    </>  
  );
}